import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { EMAIL, MAILTO, PHONE_DISPLAY, PHONE_TEL } from "@/data/site";
import { useSeo } from "@/hooks/useSeo";

export const LegalPage = ({ title, description, path = "/", updated, children, testId }) => {
  useSeo({ title: `${title} | Freedom Mobile Auto Detailing`, description, path });

  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="min-h-screen bg-obsidian" data-testid={testId}>
      <header className="border-b border-white/10">
        <div className="mx-auto flex h-[72px] max-w-3xl items-center justify-between px-5 sm:px-8">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-brand-link">
            <span className="flex h-9 w-9 items-center justify-center border border-blue-500/50 font-display text-xl font-bold text-white">F</span>
            <span className="leading-none">
              <span className="block font-display text-xl font-bold uppercase tracking-[0.08em] text-white">Freedom</span>
              <span className="mt-1 block font-mono text-[9px] font-semibold uppercase tracking-[0.3em] text-slate-400">Mobile Auto Detailing</span>
            </span>
          </Link>
          <Link to="/" className="flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-300 transition-colors hover:text-blue-400" data-testid="legal-back-link">
            <ArrowLeft size={14} />
            Back to Home
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-20">
        <p className="eyebrow">Freedom Mobile Auto Detailing</p>
        <h1 className="mt-4 font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl">{title}</h1>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">Last updated: {updated}</p>
        <div className="mt-10 space-y-8 text-base leading-relaxed text-slate-300">{children}</div>
        <div className="mt-14 border-t border-white/10 pt-8 text-sm text-slate-400">
          <p>
            Questions? Call or text{" "}
            <a href={PHONE_TEL} className="text-blue-400 hover:text-blue-300" data-testid={`${testId}-phone-link`}>{PHONE_DISPLAY}</a>{" "}
            or email{" "}
            <a href={MAILTO} className="break-all text-blue-400 hover:text-blue-300" data-testid={`${testId}-email-link`}>{EMAIL}</a>.
          </p>
        </div>
      </main>
    </div>
  );
};
